import * as stylex from '@stylexjs/stylex'
import {
  border,
  borderRadius,
  color,
  layoutTokens,
  shadow,
  size,
  spacing,
  typographyColor,
} from './tokens.stylex'

export const layout = stylex.create({
  background: {
    backgroundColor: color.surfaceBaseBackground,
    color: typographyColor.neutralBase,
    position: 'relative',
  },
  sectionWrapper: {
    paddingBlock: spacing.verticalRhythmLarge,
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
  },
  maxWidthWrapper: {
    marginInline: layoutTokens.viewportPadding,
    flexBasis: '0%',
    flexGrow: '1',
    flexShrink: '1',
    position: 'relative',
    maxWidth: size.contentMaxWidth,
  },
  contentCard: {
    border: border.surface_neutral10,
    padding: spacing.inset_med,
    borderRadius: borderRadius.surface_regular,
    // cornerShape: {
    //   default: 'none',
    //   '@supports (corner-shape: squircle)': 'squircle',
    // },
    overflow: 'clip',
    backgroundColor: color.surfaceBaseSecondary,
    boxShadow: shadow.elevationNeutralOnLight10,
    boxSizing: 'border-box',
  },
})
